import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Frame } from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';
import { store } from './store/store';
import Home from './pages/Home';
import Widget from './pages/Widget';
import Settings from './pages/Settings';
import CampaignEdit from './pages/CampaignEdit';
import AppBridgeErrorBoundary from './components/AppBridgeErrorBoundary';
import AppBridgeProvider from './components/AppBridgeProvider';
import NavigationMenuComponent from './components/NavigationMenu';

function RootRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
console.log('RootRedirect');
console.log(location);
console.log(window.location);
console.log(navigate);
console.log(location.search);
console.log(window.location.search);
  useEffect(() => {
    console.log('RootRedirect');
    console.log(location);
    console.log(window.location);
    console.log(navigate);
    console.log(location.search);
    console.log(window.location.search);
    // Preserve all query parameters when redirecting
    const searchParams = location.search || window.location.search;
    const newPath = `/app${searchParams}`;
    console.log(newPath);
    navigate(newPath, { replace: true });
  }, [navigate, location.search]);

  return null;
}

/**
 * AppContent component
 * Sets up routing and navigation according to Shopify App Bridge React documentation
 * https://shopify.dev/docs/api/app-bridge/previous-versions/app-bridge-from-npm/using-react
 */
function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();

  // Navigation links configuration (as per NavigationMenu documentation)
  const navigationLinks = [
    {
      label: 'Widget',
      destination: '/app/widget',
    },
    {
      label: 'Settings',
      destination: '/app/settings',
    },
  ];

  // Matcher function to determine active link (as per NavigationMenu documentation)
  const matcher = (link, currentLocation) => {
    return currentLocation.pathname === link.destination || 
           (link.destination !== '/app' && currentLocation.pathname.startsWith(link.destination));
  };

  return (
    <AppBridgeProvider>
      <AppBridgeErrorBoundary>
        <Frame>
          {/* NavigationMenu component - renders in Shopify Admin sidebar */}
          <NavigationMenuComponent 
            navigationLinks={navigationLinks}
            matcher={matcher}
          />
          <Routes>
            {/* Root path redirects to /app, preserving query params */}
            <Route path="/" element={<RootRedirect />} />
            <Route path="/app" element={<Home />} />
            <Route path="/app/widget" element={<Widget />} />
            <Route path="/app/settings" element={<Settings />} />
            {/* Campaign routes - must be before catch-all */}
            <Route path="/app/campaigns/new" element={<CampaignEdit />} />
            <Route path="/app/campaigns/:campaignId" element={<CampaignEdit />} />
            {/* Catch all - redirect to /app (must be last) */}
            <Route path="*" element={<Navigate to="/app" replace />} />
          </Routes>
        </Frame>
      </AppBridgeErrorBoundary>
    </AppBridgeProvider>
  );
}

/**
 * Main App component
 * Sets up according to Shopify App Bridge React documentation:
 * https://shopify.dev/docs/api/app-bridge/previous-versions/app-bridge-from-npm/using-react
 * 
 * According to docs: Provider must be a child of the router component
 * So BrowserRouter wraps AppContent which contains the Provider
 */
function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
